import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ShoppingBag } from "lucide-react";
import RazorpayButton from "@/components/RazorpayButton";

export default function Shop() {
  const [merch, setMerch] = useState([]);
  const [buying, setBuying] = useState("");

  useEffect(() => { api.get("/merch").then(r => setMerch(r.data)); }, []);

  const buy = async (m) => {
    try {
      setBuying(m.lookup_key);
      const origin_url = window.location.origin;
      const { data } = await api.post("/payments/checkout", { lookup_key: m.lookup_key, quantity: 1, origin_url });
      window.location.href = data.checkout_url;
    } catch {
      toast.error("Checkout unavailable. Try again shortly.");
      setBuying("");
    }
  };

  return (
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-12 fade-up">
      <div className="border-b-ink pb-8 mb-10">
        <div className="tag-red mb-3 inline-block">The Shop</div>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95]">Wear the record.</h1>
        <p className="font-body mt-4 max-w-2xl">
          Small line. Heavy fabrics. Honest prices. Ships worldwide within a week — or we refund without theatrics.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="shop-grid">
        {merch.map((m) => (
          <article key={m.id} className="border-ink bg-white shadow-brut-sm" data-testid={`merch-card-${m.id}`}>
            <div className="img-frame aspect-[4/5]"><img src={m.image_url} alt={m.title} loading="lazy" /></div>
            <div className="p-5">
              <div className="font-ui text-[10px] text-[#FF3333]">TBVH · {m.in_stock ? "In stock" : "Sold out"}</div>
              <h3 className="font-display text-xl mt-1 leading-tight">{m.title}</h3>
              <p className="font-quote text-base opacity-80 mt-2">{m.tagline}</p>
              <p className="font-body text-sm mt-3 opacity-80">{m.description}</p>
              <div className="flex items-center justify-between mt-5 border-t border-[#0A0A0A]/20 pt-4">
                <span className="font-display text-2xl">${m.price_usd.toFixed(2)}</span>
                <button
                  onClick={() => buy(m)}
                  disabled={buying === m.lookup_key}
                  className="btn-ink text-xs inline-flex items-center gap-2"
                  data-testid={`buy-${m.lookup_key}`}
                >
                  <ShoppingBag size={14} /> {buying === m.lookup_key ? "…" : "Stripe"}
                </button>
              </div>
              <div className="mt-2">
                <RazorpayButton lookupKey={m.lookup_key} title={m.title} className="w-full justify-center" />
              </div>
            </div>
          </article>
        ))}
      </div>

      <p className="font-mono text-xs opacity-60 mt-10">
        Stripe test card: 4242 4242 4242 4242 · any future expiry · any CVC. Razorpay running in mock mode until keys are wired.
      </p>
    </div>
  );
}
